<!-- 定制菜单（直播带货专属） -->
<template>
  <div>
    <!-- 前面4个菜单 -->
    <div
      class="side-menu"
      v-for="menu in topMenus"
      :key="menu.key"
      :class="{
        selected: selectKind == menu.key,
        disable: disabled(menu)
      }"
      @click="handleClick(menu.key, menu)"
    >
      <i :class="menu.iconCls"></i>
      <span class="text">{{ $t(menu.name) }}</span>
    </div>

    <!-- 更多菜单 -->
    <vh-popover
      placement="right-start"
      width="182"
      trigger="hover"
      popper-class="more-menus-popper"
      v-model="showMenusPopper"
      v-if="moreMenus.length"
    >
      <div class="more-menus">
        <div
          class="more-menus-item"
          v-for="menu in moreMenus"
          :key="menu.key"
          :class="{
            selected: selectKind == menu.key,
            disable: disabled(menu)
          }"
          @click="handleClick(menu.key, menu)"
        >
          <i :class="menu.iconCls"></i>
          <span>{{ $t(menu.name) }}</span>
        </div>
      </div>
      <div class="side-menu" slot="reference">
        <i class="vh-iconfont vh-a-vh-line-moreitems"></i>
        <span class="text">{{ $t('host.k_502001') }}</span>
      </div>
    </vh-popover>

    <!-- 分享 -->
    <div
      class="side-menu menu-footer"
      @click="handleClick('share')"
      v-if="hasAuth('ui.hide_share')"
    >
      <i class="vh-iconfont vh-line-share"></i>
      <span class="text">{{ $t('aside_menu.aside_menu_1006') }}</span>
    </div>

    <!--
    直播带货模式统一列表/主操作区域，在 live-split-view 组件中处理，
    已经改造的组件包括：抽奖，快问快答,签到，商城奖励，观看有礼
  -->

    <!-- 弹窗需要用到的相关组件 -->
    <!-- 抽奖 -->
    <VmpLotteryLive v-if="hasAuth('ui.hide_lottery')"></VmpLotteryLive>
    <!-- 快问快答 -->
    <VmpExam v-if="hasAuth('exam')"></VmpExam>
    <!-- 问卷 -->
    <VmpQuestionnaire ref="refQuestionnaire" v-if="hasAuth('ui.hide_survey')"></VmpQuestionnaire>
    <!-- 问答 VmpQa 组件在全局有加载了，这里不需要加载 -->
    <!-- 红包 -->
    <VmpRedPacketLive
      ref="refRedpacket"
      v-if="hasAuth('ui.show_redpacket') && isLiving"
    ></VmpRedPacketLive>
    <!-- 计时器 VmpLiveTimerSet 组件在全局有加载了，这里不需要加载 -->
    <!-- 推屏卡片 -->
    <VmpCard ref="refPushCard" v-if="hasAuth('push_screen_card')"></VmpCard>
    <!-- 转播 VmpRebroadcastList 组件在全局有加载了，这里不需要加载 -->
    <!-- 现金红包 -->
    <CashRedPacket
      v-if="hasAuth('ui.hide_survey') && isCashRedpacket"
      @close="isCashRedpacket = false"
      :dialogVisible.sync="isCashRedpacket"
      :webinarId="webinarId"
    ></CashRedPacket>
  </div>
</template>
<script>
  import menuConfig from './menu-config.js';

  export default {
    name: 'AsideMenu3',
    components: {
      CashRedPacket: () => import('@/packages/cash-redpacket/live.vue')
    },
    data() {
      return {
        // 当前在中间内容区打开的功能，对话框模式的功能不算
        selectKind: '',
        menus: menuConfig.menus,
        showMenusPopper: false,
        isCashRedpacket: false
      };
    },
    computed: {
      //互动工具状态
      interactToolStatus() {
        const { interactToolStatus = {} } = this.$domainStore.state.roomBaseServer;
        return interactToolStatus;
      },
      webinarId() {
        return this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.id;
      },
      // 考虑后面，如果前面菜单不足4个，更多中的菜单拿出来自动补齐
      // allPermittedMenus() {
      //   return this.menus.filter(item => {
      //     return (
      //       [1, 3, 4].includes(this.roleName) && this.configList[item.authKey] && !this.auth_gd
      //     );
      //   });
      // },
      topMenus() {
        return this.menus.slice(0, 4).filter(item => {
          return this.hasAuth(item.authKey);
        });
      },
      moreMenus() {
        return this.menus.slice(4).filter(item => {
          return this.hasAuth(item.authKey);
        });
      },
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      },
      // 是否在直播中
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      },
      // 是否正在三方推流
      isThirdStream() {
        return this.$domainStore.state.roomBaseServer.isThirdStream;
      }
    },
    methods: {
      disabled(menu) {
        if (typeof menu.disable === 'boolean' && menu.disable) {
          return true;
        }
        return menu.useInLiving ? !this.isLiving : false;
      },
      // 是否有权限
      hasAuth(authKey) {
        return [1, 3, 4].includes(this.roleName) && this.configList[authKey] && !this.auth_gd;
      },
      handleClick(kind, menu) {
        if (menu) {
          if (!this.hasAuth(menu.authKey)) return;
          if (menu.useInLiving && !this.isLiving) return;
        }
        switch (kind) {
          // 问卷
          case 'questionnaire':
            this.$refs?.['refQuestionnaire'].open();
            break;
          // 问答
          case 'qa':
            this.$emitter.emit(this.$EMIT_DEFINE.interact_tools_icon_click, kind);
            break;
          // 红包
          case 'redpacket':
            this.$refs?.['refRedpacket'].open();
            break;
          case 'timer':
            {
              const liveTimerSet = window.$middleEventSdk?.serverPool.get('liveTimerSet');
              if (!liveTimerSet || liveTimerSet.timerVisible) return;

              const liveTimer = window.$middleEventSdk?.serverPool.get('liveTimer');
              if (!liveTimer || liveTimer.timerVisible) return;

              this.$emitter.emit(this.$EMIT_DEFINE.interact_tools_icon_click, kind);
            }
            break;
          case 'pushcard':
            this.$refs?.['refPushCard'].open();
            break;
          case 'rebroadcast':
            this.$emitter.emit(this.$EMIT_DEFINE.interact_tools_icon_click, kind);
            break;
          case 'cashredpacket':
            this.isCashRedpacket = true;
            break;
          default:
            this.$emitter.emit(this.$EMIT_DEFINE.live_sidemenu_change, { kind });
            break;
        }
        this.showMenusPopper = false;
      },
      sidemenuStatusChange({ kind }) {
        this.selectKind = kind ? kind : '';
      }
    },
    created() {
      this.$emitter.on(this.$EMIT_DEFINE.live_sidemenu_change, this.sidemenuStatusChange);
    },
    beforeDestroy() {
      this.$emitter.off(this.$EMIT_DEFINE.live_sidemenu_change, this.sidemenuStatusChange);
    }
  };
</script>
<style lang="less">
  .side-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #ececec;
    padding: 10px 0px;
    cursor: pointer;

    span.text {
      font-size: 12px;
      user-select: none;
    }
    i {
      user-select: none;
      display: block;
      width: 23px;
      height: 23px;
      margin: 0 auto;
      padding-bottom: 6px;
      font-size: 22px;
    }

    &.selected {
      span.text,
      i {
        color: #fb3a32;
      }
    }

    &.disable {
      cursor: not-allowed;
      span.text,
      i {
        color: #777777;
      }
    }

    &.menu-footer {
      position: absolute;
      width: 100%;
      bottom: 10px;
    }
  }

  .more-menus-popper {
    left: 48px !important;
    border-radius: 0;
    background: #434343;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #2d2d2d;
    padding: 0 10px 20px 10px;
    z-index: 110;
  }
  .more-menus {
    display: flex;
    flex-wrap: wrap;
    &-item {
      flex-shrink: 0;
      width: 52px;
      margin-top: 20px;
      font-size: 12px;
      color: #ececec;
      text-align: center;
      cursor: pointer;

      i {
        display: block;
        margin: 0 auto;
        font-size: 16px;
        padding-bottom: 4px;
      }

      &:hover:not(.disable) {
        color: #fb3a32;
      }

      &.selected:not(.disable) {
        color: #fb3a32;
      }

      &.disable {
        pointer-events: none; // 不可点击
        cursor: not-allowed;
        i,
        span {
          color: #777777;
          user-select: none;
        }
      }
    }
  }
</style>
